import React from 'react';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useStyles } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useAdaptedSettings, useDynamicElement, useStylesParams } from '../../../../../hooks';
import { st, classes } from './PlanName.st.css';

interface Props {
  planId: string;
  name: string;
  highlighted: boolean;
}

export const PlanName: React.FC<Props> = ({ planId, name, highlighted }) => {
  const { isMobile } = useEnvironment();
  const stylesParams = useStylesParams();
  const styles = useStyles();
  const settings = useAdaptedSettings();
  const { registerRef, heightByPlanId } = useDynamicElement('planName');
  const showPlanName = styles.get(stylesParams.showPlanName);
  const PlanNameTitleTag = settings.get('planTitleHtmlTag') as keyof React.JSX.IntrinsicElements;
  const ref = React.useMemo(() => registerRef(planId), [planId]);

  if (!showPlanName) {
    return null;
  }

  return (
    <PlanNameTitleTag
      data-hook={VIEWER_HOOKS.PLAN_NAME}
      aria-describedby={highlighted ? 'ribbon' : undefined}
      className={st(classes.planTitle, { highlighted, mobile: isMobile })}
      style={{ height: heightByPlanId.get(planId) }}
    >
      <span className={classes.block} ref={ref}>
        {name}
      </span>
    </PlanNameTitleTag>
  );
};
